
const addToBagButton = document.querySelector('.add-to-bag');

const postAddAnalytics = () => {
  try {
    /*
    // GA event
    if (ga) {
      if (window.location.href.split('/products/')[1]) {
        const handle = window.location.href.split('/products/')[1];
        ga('send', 'event', 'Cart', 'Added Product', handle);
      } else {
        ga('send', 'event', 'Cart', 'Added Product');
      }
    }
    */

    // Pinterest event
    let productPriceElement = document.getElementById('product-price');
    if (productPriceElement == undefined) {
      productPriceElement = document.querySelector('span[itemprop="priceCurrency"]')
    }
    if (productPriceElement) {
      let productPrice = productPriceElement.textContent;
      productPrice = productPrice.replace(/[\s,]+/g,'')
      productPrice = productPrice.slice(1)
      // Split if there are decimal points
      productPrice = productPrice.split('.')[0]
      pintrk('track', 'addtocart', {
        value: (parseFloat(productPrice)),
        order_quantity: 1,
        currency: Shopify.currency.active,
      });
    }
  } catch (err) {
    console.log(err)
  }
}

if(addToBagButton) {

  addToBagButton.addEventListener('click', e => {

    const customiseSections = document.querySelectorAll('.customise-section');

    // Check for incomplete required sections
    let allRequirementsComplete = true;
    if(productCustomise.sections.length) {
      for (let i = 0; i < productCustomise.sections.length; i++) {
        let section = productCustomise.sections[i];
        if (section.required == true && section.complete == false) {
          // Set to false
          allRequirementsComplete = false;
          // Display prompt
          let thisCustomiseSectionPrompt = Array.from(customiseSections)[i].querySelector('.customise-prompt');
          thisCustomiseSectionPrompt.style.display = 'block';
          // Highlight prompt(s)
          thisCustomiseSectionPrompt.classList.remove('shine');
          setTimeout(() => { thisCustomiseSectionPrompt.classList.add('shine'); }, 100);
        }
      }
    }

    // Check all requirements are fulfilled AND check availability isn't pending
    if (allRequirementsComplete == true && productCustomise.selection.availability_status !== 'pending-restock') {

      // If we're adding the availability message as a hidden prop.
      if (cart.config.availabilityStatusProp) {
        let availabilityMessage = `Ships in ${productCustomise.selection.shipping_time}`; // prepend "Ships in" text
        if(
          productCustomise.selection.shipping_time.toLowerCase().indexOf('pre-order') >= 0 ||
          productCustomise.selection.shipping_time.toLowerCase().indexOf('sent by email') >= 0
        ) {
          availabilityMessage = productCustomise.selection.shipping_time; // without "Ships in" text
        }
        // Edit the properties to include a hidden one (underscore) about availability message
        productCustomise.selection.props = {
          _availability_state: availabilityMessage,
          ...productCustomise.selection.props,
        }
      }

      // Add product data to cartItemsData array
      let cartItemsData = [{ 'id': productCustomise.selection.variant_id, 'quantity': 1, 'properties': productCustomise.selection.props }];

      // Check for completed add-ons
      if(productCustomise.sections.length) {
        for (let i = 0; i < productCustomise.sections.length; i++) {
          let section = productCustomise.sections[i];
          if (section.add_on == true && section.complete == true) {
            let addOnProps = {}; // init
            // Check for existing add-on props
            if (section.customise_prop) {
              let addOnTitle = section.options.find(option => option.variant_id == section.add_on_variant_id).variant_title;
              addOnProps[section.customise_prop] = addOnTitle;
            }
            // Append 'Added to' prop
            let addOnParentProduct = document.querySelector('#product-info h1').getAttribute('data-product-title');
            if (productCustomise.selection.props.Initials) {
              addOnParentProduct = `${addOnParentProduct} (${productCustomise.selection.props.Initials})`;
            }
            addOnProps['Added to'] = addOnParentProduct;
            // Add add-on data to start of cartItemsData array
            cartItemsData.unshift({ 'id': section.add_on_variant_id, 'quantity': 1, 'properties': addOnProps});
          }
        }
      }

      // Check for upgrades
      if(productCustomise.selection.props['Upgrades']) {
        productCustomise.selection.props['Upgrades'].split(', ').forEach(upgrade => {
          let parentProduct = document.querySelector('#product-info h1').getAttribute('data-product-title');
          let upgradeButton = document.querySelector(`#product-info .upgrade-button[data-upgrade-variant-title='${upgrade}']`);
          let upgradeVariantId = parseInt(upgradeButton.getAttribute('data-upgrade-variant-id'));
          let upgradeProps = { '_added_to': `${parentProduct} - ${productCustomise.selection.variant_title}` };
          // Add upgrade data to start of cartItemsData array
          cartItemsData.unshift({ 'id': upgradeVariantId, 'quantity': 1, 'properties': upgradeProps });
        });
      }

      cart.navIcon.classList.add('new');
      cart.addMultiple(cartItemsData, false)

      .then(function(){
        postAddAnalytics();

        // Open cart drawer (delay time in dynamic-cart-update.js)
        setTimeout(() => {
          if (cart.config.openOnAddToBag) {
            cart.refresh().then(() => cart.open())
          }
        }, cart.config.openOnAddToBagDelay);

        // Reset everything after cart drawer opens (delay time in dynamic-cart-update.js)
        setTimeout(() => {

          // Reset customisation
          if(productCustomise.sections.length) {
            for (let i = 0; i < productCustomise.sections.length; i++) {
              let section = productCustomise.sections[i];
              // Reset product customise object
              section.complete = section.customisation_type == 'discs' ? true : false;
              if (section.add_on_variant_id) {
                section.add_on_variant_id = null;
              }
              // Reset customise sections
              let thisCustomiseSection = Array.from(customiseSections)[i];
              thisCustomiseSection.classList.remove('complete');
              thisCustomiseSection.innerHTML = section.default_innerHTML;
              // Register event listeners
              registerCustomiseEventListeners(thisCustomiseSection);
            }
          }
          // Reset Upgrades
          let upgradeButtons = document.querySelectorAll('#product-info .upgrade-button');
          if(upgradeButtons.length) {
            upgradeButtons.forEach(btn => btn.classList.remove('active'));
          }
          // Reset productCustomise object
          productCustomise.selection.variant_id = productTop.getAttribute('data-selected-variant-id') ? productTop.getAttribute('data-selected-variant-id') : null;
          productCustomise.selection.availability_status = productTop.getAttribute('data-product-availability') ? productTop.getAttribute('data-product-availability') : null;
          productCustomise.selection.props = {};
          productCustomise.selection.upgrades = [];
          // Reset cart icon
          cart.navIcon.classList.remove('new');
          // Reset CTA button
          ctaState();

        }, (cart.config.openOnAddToBagDelay + cart.config.drawerSlideInTime));

      });

    } // if allRequirementsComplete == true

  });

} // if addToBagButton (none if product is unavailable)













/*
// Notify

const notifyTrigger = document.getElementById('notify-trigger');
if(notifyTrigger) {

  const notifyOverlay = document.getElementById('notify-overlay');
  const notifyOverlayModal = notifyOverlay.querySelector('.modal');
  let notifyOverlayModalHeight = notifyOverlayModal.offsetHeight;
  const notifyFormEmbed = document.getElementById('notify-form-embed')
  const productTitle = notifyFormEmbed.getAttribute('data-product-title');
  const notifyProductsCookieName = 'notify_products';

  // Open Notify overlay
  notifyTrigger.addEventListener('click', e => {
    notifyOverlay.classList.add('active');
    notifyOverlayModalHeight = notifyOverlayModal.offsetHeight; // Update modal height (with form fully loaded)
  });

  // On Notify form submission
  window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'submit') {
      // console.log(e.detail);

      // Mark as complete and freeze modal height
      notifyOverlay.classList.add('complete');
      notifyOverlayModal.style.minHeight = `${notifyOverlayModalHeight}px`;

      // Update cookie
      // Note: Klaviyo requires a list as a string in the form ["apples","bananas","oranges"]
      // Ref: https://help.klaviyo.com/hc/en-us/articles/8557592023451-Troubleshooting-invalid-format-error-messages-
      let notifyProductsCookieValue = getCookie(notifyProductsCookieName); // Check for notify_products cookie
      if (notifyProductsCookieValue) {
        notifyProductsCookieValue = notifyProductsCookieValue.slice(1).slice(0, -1); // remove outer brackets from string
        let notifyProductsArray = notifyProductsCookieValue.split(','); // cookie string to array
        if(notifyProductsArray.includes(`"${productTitle}"`) == false) { // add product (with quotes) to array if not already there
          notifyProductsArray.push(`"${productTitle}"`);
          notifyProductsCookieValue = notifyProductsArray.join(','); // array to string
          notifyProductsCookieValue = `[${notifyProductsCookieValue}]`; // wrap in brackets
          setCookie(notifyProductsCookieName, notifyProductsCookieValue, 365);
        }
      }
      else {
        notifyProductsCookieValue = `["${productTitle}"]`; // array with single item as string
        setCookie(notifyProductsCookieName, notifyProductsCookieValue, 365);
      }

      // Push cookie value to custom property in profile
      // Ref: https://developers.klaviyo.com/en/v1-2/docs/track-klaviyo-form-activity-using-javascript
      let _learnq = window._learnq || [];
      _learnq.push(['identify', {
        'Notify products' : notifyProductsCookieValue
      }]);

      // Refresh page on modal close
      let closeButton = notifyOverlay.querySelector('.modal-close');
      closeButton.addEventListener('click', function(e) {
        window.location.reload();
      });
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.modal')){
          window.location.reload();
        }
      });

    }
  });

} // if notifyTrigger
*/